import axios from 'axios';
import {
  GET_MATCH_CARD_HOT_BETS_REQUEST,
  GET_MATCH_CARD_HOT_BETS_SUCCESS,
  GET_MATCH_CARD_HOT_BETS_FAILURE,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';

export const getMatchCardHotBets = (eventId, isLive) => async dispatch => {
  try {
    dispatch({
      type: GET_MATCH_CARD_HOT_BETS_REQUEST
    });

    const bulletinType = isLive ? 1 : 2;
    
    const res = await axios.get(
      '/mobile/match-card/hot-bets',
      {
        params: {
          bulletinType,
          eventId
        }
      }
    );

    const responseData = res?.data || {};
    const transformedData = responseData.markets?.map(market => ({
      ...responseData.event,
      market
    })) || [];

    dispatch({
      type: GET_MATCH_CARD_HOT_BETS_SUCCESS,
      payload: transformedData
    });

    return transformedData;

  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_HOT_BETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

